export default "__VITE_ASSET__3ccf7482__"